import { ToastContainer, ToastMessageAnimated } from "@bitjourney/react-toastr";
import type { FC, MutableRefObject, ReactNode } from "react";
import { createRef, Component, createElement } from "react";

import { kibelaCookie } from "../../utils/kibelaCookie";
import { Portal } from "../Portal";

const DEFAULT_TIMEOUT = 5 * 1000;
const ERROR_TIMEOUT = 10 * 1000;

const ToastMessageFactory: FC<any> = (props) => createElement(ToastMessageAnimated, props);

export interface Messages {
  success?: ReactNode;
  notice?: ReactNode;

  error?: ReactNode;
  alert?: ReactNode;
}

export interface StringMessages {
  success?: string;
  notice?: string;

  error?: string;
  alert?: string;
}

interface Props {
  initialMessages?: Messages;
}

export class Toast extends Component<Props> {
  readonly toastContainer: MutableRefObject<ToastContainer> = createRef<ToastContainer>();
  readonly handleToastContainer: (element: ToastContainer) => void;

  constructor(props: Props) {
    super(props);

    this.handleToastContainer = (element) => {
      this.toastContainer.current = element;
      this.showToast(this.props.initialMessages);
    };
  }

  setToast(messages: StringMessages) {
    const prev = kibelaCookie.get("toast_message");
    const prevParsed = prev && JSON.parse(prev);
    kibelaCookie.set("toast_message", JSON.stringify({ ...prevParsed, ...messages }));
  }

  // @param messages
  showToast(messages: Messages | undefined) {
    for (const type in messages) {
      const message = messages[type];
      if (message == null) {
        return;
      }

      const toastOptions = {
        timeOut: type === "error" || type === "alert" ? null : DEFAULT_TIMEOUT,
        extendedTimeOut: type === "error" || type === "alert" ? ERROR_TIMEOUT : DEFAULT_TIMEOUT,
        showAnimation: "animate__animated animate__fadeInUp",
        hideAnimation: "animate__animated animate__fadeOutDown",
        closeButton: true,
      };

      if (type === "success" || type === "notice") {
        this.toastContainer.current.success(message, null, toastOptions);
      } else if (type === "error" || type === "alert") {
        this.toastContainer.current.error(message, null, toastOptions);
      } else {
        throw new Error(`Unexpected message type: ${type}`);
      }
    }
  }

  render() {
    return (
      <Portal portalClassName="toast-portal">
        <ToastContainer
          ref={this.handleToastContainer}
          className="toast-position"
          toastMessageFactory={ToastMessageFactory}
        />
      </Portal>
    );
  }
}
